<template>
<div>
    <v-tabs show-arrows v-model="tab">
        <v-tab
          data-testid="call-modal-contact-details-tab"
          class="call-modal-contact-details-tab"
        >
          Contact Details
        </v-tab>
        <v-tab
          data-testid="call-modal-contact-notes-tab"
          class="call-modal-contact-notes-tab"
        >
          Contact Notes
        </v-tab>
        <v-tab
          data-testid="call-modal-add-note-tab"
          class="call-modal-add-note-tab"
        >
          Add Note
        </v-tab>
    </v-tabs>
        <v-tabs-items v-model="tab">
        <v-tab-item eager>
            <v-layout v-if="unitFeaturesLoading" justify-center>
                <v-progress-circular
                    :size="60"
                    :width="6"
                    indeterminate
                    class="my-3"
                />
            </v-layout>
            <v-layout v-else align-start class="my-4">
                <v-layout column class="subheading" style="width: 650px">
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Name: </v-flex>
                        <v-flex xs6 data-testid="tenant-name">{{ tenantName }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Home Phone Number: </v-flex>
                        <v-flex xs6 data-testid="tenant-home-phone">{{ tenantHomePhone }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Mobile Phone Number: </v-flex>
                        <v-flex xs6 data-testid="tenant-mobile-phone">{{ tenantMobilePhone }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Email: </v-flex>
                        <v-flex xs6 data-testid="tenant-email">{{ tenantEmail }}</v-flex>
                    </v-layout>
                    <v-layout class="subheading mx-2 my-1">
                        <v-flex xs4>Move-in Date: </v-flex>
                        <v-flex xs6 data-testid="tenant-move-in">{{ tenantMoveIn }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>In Auction: </v-flex>
                        <v-flex xs6 data-testid="tenant-auction-status">
                            {{ auctionDate ? 'Yes' : 'No' }}
                        </v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Auction Date: </v-flex>
                        <v-flex xs6 data-testid="tenant-auction-date">
                            {{ auctionDate ? auctionDate : 'N/A' }}
                        </v-flex>
                    </v-layout>
                    <v-form ref="form" class="mt-4 ml-1" style="width: 515px">
                        <v-text-field
                            data-testid="call-id-input"
                            class="call-id-input"
                            outlined
                            label="Call ID"
                            placeholder="Enter Call ID..."
                            type="number"
                            required
                            :rules="inputRules"
                            v-model="ctmId"
                        />
                    </v-form>
                </v-layout>

                <v-layout column class="subheading" style="width: 500px">
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Unit Number: </v-flex>
                        <v-flex xs6 data-testid="unit-number">{{ unitName }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Unit Type: </v-flex>
                        <v-flex xs6 data-testid="unit-type">{{ unitType }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Unit Size: </v-flex>
                        <v-flex xs6 data-testid="unit-size">{{ unitSize }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Facility Name: </v-flex>
                        <v-flex xs6 data-testid="facility-name">{{ facilityName }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Location Code: </v-flex>
                        <v-flex xs6 data-testid="location-code">{{ locationCode }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 my-1">
                        <v-flex xs4>Facility Phone: </v-flex>
                        <v-flex xs6 data-testid="facility-phone">{{ addDashes(facilityPhone) }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2 mt-1">
                        <v-flex xs4>Address: </v-flex>
                        <v-flex xs6 data-testid="facility-address-1">{{ facilityAddressLine1 }}</v-flex>
                    </v-layout>
                    <v-layout class="mx-2">
                        <v-flex xs4 />
                        <v-flex xs6 data-testid="facility-address-2">{{ facilityAddressLine2 }}</v-flex>
                    </v-layout>
                </v-layout>
            </v-layout>
        </v-tab-item>
        <v-tab-item eager>
            <v-layout v-if="ledgerNotesLoading" justify-center>
                <v-progress-circular
                    :size="60"
                    :width="6"
                    indeterminate
                    class="my-3"
                />
            </v-layout>
            <v-layout
                v-else-if="ledgerNotes.length"
                column
                style="max-height: 400px; outline: 1px grey solid; overflow-y:auto;"
                class="mt-4 mb-3"
            >
                <span class="ml-3 mt-3 mb-2 text-h6" data-testid="note-tenant-name">
                    Notes for {{ tenantName }}:
                </span>
                <v-divider class="mx-3 mt-1"></v-divider>

                <v-layout column>
                    <v-flex
                        v-for="(note, i) of ledgerNotes"
                        :key="i"
                        class="ma-3"
                        data-testid="note-container"
                    >
                        <v-layout column class="my-1" style="font-size:1rem">
                            <div class="font-weight-bold pb-2" v-if="note.title">{{ note.title }}</div>
                            <div data-testid="note-text">{{ note.description }}</div>
                            <v-layout class="mt-1" align-center>
                                <v-icon class="mr-1" size="medium">create</v-icon>
                                <span class="text-caption" data-testid="note-date">
                                    Created {{ note.author ? `by ${note.author}` : '' }} on {{ timestamp(note.created_at) }}
                                </span>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-layout v-else class="pa-2 mt-3 text-h6">There are no notes for {{ tenantName }}</v-layout>
        </v-tab-item>
        <v-tab-item eager>
            <v-textarea
                data-testid="call-modal-add-note-textarea"
                class="call-modal-add-note-textarea px-2 pt-4"
                v-model="note"
                filled
                hint="When you are finished, click 'Add Note' to save this note to this tenant's account."
                label="Add Note"
            />
            <v-layout justify-end align-center>
                <div>
                    <v-checkbox
                        data-testid="call-modal-notify-manager-checkbox"
                        class="call-modal-notify-manager-checkbox"
                        style="margin:0 8px"
                        v-model="sendLedgerNote"
                        label="Notify Store Manager"
                        input-value="true"
                        hide-details
                        :disabled="!note"
                    />
                </div>

                <v-btn
                    data-testid="call-modal-add-note-btn"
                    class="call-modal-add-note-btn success"
                    @click="addLedgerNote"
                    :loading="noteLoading"
                    :disabled="!note"
                    small
                >Add Note</v-btn>
            </v-layout>
        </v-tab-item>
    </v-tabs-items>
    </div>
</template>

<script>
import { emailRules, inputRules } from "@/helpers/form-rules";
import { dateMethodMixins } from "@/mixins/dateMethodMixins";
import moment from "moment";

export default {
  props: {
    callData: {
      type: [Object, String],
      default: ""
    },
    callId: {
      type: String,
      default: ""
    }
  },
  mixins: [dateMethodMixins],
  data() {
    return {
      emailRules: emailRules,
      inputRules: inputRules,
      ledgerNotes: [],
      ledgerNotesLoading: false,
      loading: false,
      note: "",
      noteLoading: false,
      sendLedgerNote: false,
      unitFeatures: [],
      unitFeaturesLoading: false,
      tab: 0
    };
  },
  methods: {
    async initializeCallModal() {
      this.loading = true;
      let payload = {
        facilityId: this.callData.facility_id,
        tenantId: this.callData.tenant_id,
        ledgerId: this.callData.ledger_id,
        facility_id: this.callData.facility_id,
        unit_id: this.callData.unit_id
      };
      await this.getUnitFeatures(payload);
      await this.getLedgerNotes(payload);
      this.loading = false;
    },
    addDashes(phone) {
      if (phone) {
        if (phone.length === 10 && typeof phone.replace === "function") {
          return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          return phone;
        }
      }
    },
    timestamp(date) {
      return moment(date).format("MM/DD/YYYY, h:mm a");
    },
    getUnitFeatures(payload) {
      this.unitFeaturesLoading = true;
      this.$store.dispatch("getUnitFeatures", payload)
        .then(resp => {
          this.unitFeatures = resp.data;
          this.unitFeaturesLoading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.unitFeaturesLoading = false;
        });
    },
    getLedgerNotes(payload) {
      this.ledgerNotesLoading = true;
      this.$store.dispatch("getLedgerNotes", payload)
        .then(resp => {
          this.ledgerNotes = this.sortNotes(resp.data);
          this.ledgerNotesLoading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.ledgerNotesLoading = false;
        });
    },
    addLedgerNote() {
      this.noteLoading = true;
      let payload = {
        facilityId: this.callData.facility_id,
        tenantId: this.callData.tenant_id,
        ledgerId: this.callData.ledger_id,
        description: this.note,
        notify_store_manager: this.sendLedgerNote
      };
      this.$store.dispatch("createLedgerNote", payload)
        .then(resp => {
          this.noteLoading = false;
          this.$store.dispatch("handleSuccess", "Ledger note added!");
          this.note = "";
          this.ledgerNotes = this.sortNotes(resp.data);
        })
        .catch(err => {
          this.noteLoading = false;
          this.$store.dispatch("handleError", err);
        });
    },
    sortNotes(notes) {
      return notes.sort((a, b) => {
        let date1 = new Date(a.created_at).getTime();
        let date2 = new Date(b.created_at).getTime();
        return date2 - date1;
      });
    }
  },
  computed: {
    ctmId: {
      get() {
        return this.callId;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },
    validEmail() {
      let regex = /^\S+@\S+\.\S+$/;
      return regex.test(this.customerEmail);
    },
    tenantName() {
      return this.callData ? this.callData.name : "";
    },
    tenantHomePhone() {
      return this.callData ? this.addDashes(this.callData.phone_home) : "";
    },
    tenantMobilePhone() {
      return this.callData ? this.addDashes(this.callData.phone_mobile) : "N/A";
    },
    tenantEmail() {
      return this.callData ? this.callData.email : "";
    },
    tenantMoveIn() {
      return this.callData ? this.formatDate(this.callData.moved_in) : "";
    },
    auctionDate() {
      return this.callData && this.callData.auction_date ? this.formatDate(this.callData.auction_date) : "";
    },
    unitName() {
      return this.callData ? this.callData.unit_name : "";
    },
    unitNumber() {
      return this.callData ? this.callData.unit_id : "";
    },
    unitType() {
      return this.callData ? this.callData.unit_type : "";
    },
    unitSize() {
      return this.callData ? this.callData.unit_size : "";
    },
    facilityName() {
      return this.callData ? this.callData.facility_name : "";
    },
    locationCode() {
      return this.callData ? this.callData.facility_location_code : "";
    },
    facilityPhone() {
      return this.callData ? this.callData.facility_phone : "";
    },
    facilityAddressLine1() {
      return this.callData ? this.callData.facility_street_address : "";
    },
    facilityAddressLine2() {
      const callData = this.callData;
      return callData
        ? callData.facility_city + ", " + callData.facility_state + " " + callData.facility_postal_code
        : "";
    }
  },
  created() {
    this.initializeCallModal();
  }
};
</script>
